export default __webpack_public_path__ + "media/img/mappin-active-913b70519bc651f7dd36ee03d2c9f96c.svg";